<ngx-ui-loader></ngx-ui-loader>
<app-maintenance-notification></app-maintenance-notification>
<router-outlet></router-outlet>
